module.exports = __webpack_public_path__ + "img/invitation_hero_new.8eb98464.jpg";